import { Rgb } from "../types";

const THIRD_TURN = (2 * Math.PI) / 3; // R, G, B phases 120° apart so each peaks in turn

export function rainbowRgb(timeSec: number, speed: number): Rgb {
    const channel = (phase: number) => 127.5 + 127.5 * Math.sin(timeSec * speed + phase);
    return [channel(0), channel(THIRD_TURN), channel(2 * THIRD_TURN)];
}
